/* eslint-disable no-nested-ternary */
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { Button, Form, Input, Modal, Spin } from "antd";
import { getEnv } from "@/utils";

import { getUrlParams } from "@/utils";

import styles from "./index.module.scss";

const TkauthRedirect = () => {
  const hostConfig: any = {
    dev: "test.us.9five.cn",
    test: "test.us.9five.cn",
    uat: "test.us.9five.cn",
    prod: "seller-us.9five.ai",
  };

  const history = useHistory();
  useEffect(() => {
    const code = getUrlParams("code");
    const state = getUrlParams("state");
    const currentSearch = window.location.search;

    const stateData = JSON.parse(decodeURIComponent(state || "{}") || "{}");

    if (stateData?.redirectUrl) {
      const params = new URLSearchParams(currentSearch);

      // 只替换 state 参数，重新编码
      params.set("state", encodeURIComponent(JSON.stringify(stateData)));
      console.log(`${stateData.redirectUrl}?${params.toString()}`);
      // 其他参数保持不变（code、app_key 等）
      window.open(`${stateData.redirectUrl}?${params.toString()}`, "_blank");

      return;
    }

    if (code) {
      const pathMenu = {
        shop: "/tkauth",
        video: "/tk-video-auth",
      };

      if (!state) {
        window.location.href = `https://${hostConfig.prod}${pathMenu.shop}${currentSearch}`;
        return;
      }

      if (stateData?.env !== getEnv()) {
        // 跳转到新 host，保留路径和参数
        window.location.href = `https://${hostConfig[stateData?.env]}${pathMenu[stateData?.type]}${currentSearch}`;
      } else {
        history.push(`${pathMenu[stateData?.type]}${currentSearch}`);
      }
    }
  }, []);

  return (
    <>
      <Spin spinning>
        <div className={styles.content}></div>
      </Spin>
    </>
  );
};

export default withRouter(TkauthRedirect);
